import * as React from 'react'

const Root: React.FC = ({ children }) => <>{children}</>

export default Root
